export default __webpack_public_path__ + "static/media/cat-error.111a0d46.svg";